import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { ParComplaintsTasksService } from '../../services/par_complaints_tasks/par-complaints-tasks.service';
import { environment } from '../../../environments/environment';
import { GoogleAnalyticsService } from '../../services/google_analytics/google-analytics.service';

@Component({
  selector: 'par-del-task',
  templateUrl: './par-complaints-tasks-del-dialog.component.html',
  styleUrls: ['./par-complaints-tasks-del-dialog.component.css']
})
export class parComplaintsTasksDelDialog implements OnInit {
  id: any;
  DocTypeErrMsg;
  DocTypeErr: boolean = false;
  firstName;
  lastName;
  loginId;

  constructor(private parComplaintsTasksService: ParComplaintsTasksService,
    public dialogRef: MatDialogRef<parComplaintsTasksDelDialog>,
    @Inject(MAT_DIALOG_DATA) public complaintTaskData: any,
    private googleAnalyticsService: GoogleAnalyticsService) {
  }

  ngOnInit() {
    this.loginId = localStorage.getItem('loginID');
    this.firstName =  localStorage.getItem("username");
    this.lastName = localStorage.getItem('Lastname');
   }

  onNoClick(): void {
    this.dialogRef.close();
  }

  deleteComplaintsTask() {
    this.id = this.complaintTaskData.Doc_Id;
    this.parComplaintsTasksService.deleteComplaintsTasks(this.id, this.complaintTaskData.ComplaintId).subscribe(res => {
      this.googleAnalyticsService.emitEvent(this.firstName + ' ' + this.lastName,environment.googleAnalyticsEvents[5],this.loginId, 1);
      this.parComplaintsTasksService.load.next('success');
      this.onNoClick();
    }, error => {
      this.DocTypeErrMsg = "Delete par complaints task" + error;
      this.DocTypeErr = true;
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/components/par-complaints-tasks-del-dialog/par-complaints-tasks-del-dialog.component.ts